<div class="header">{{header}} 
    <app-info-button *ngIf="infoButton" [linkArray]="infoButton.linkArray" [title]="infoButton.infoTitle" [htmlText]="infoButton.htmlText"></app-info-button>
</div>
<div class="body">
    <ng-content></ng-content>
</div>